export default __webpack_public_path__ + "static/media/Rangers.950e9d60.png";